var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0385 4.2477C18.0978 1.9355 15.2801 2.0004 15.2801 2.0004L14.9922 2.3462C18.4884 3.4482 20.1131 5.0687 20.1131 5.0687C15.1111 2.1751 8.7398 2.196 3.5371 5.0687C3.5371 5.0687 5.2235 3.3616 8.9254 2.2595L8.7199 2.0002C8.7199 2.0002 5.9227 1.9355 2.9615 4.2473C2.9615 4.2473 0 9.8439 0 16.737C0 16.737 1.72765 19.8487 6.2726 20C6.2726 20 7.0335 19.0492 7.6504 18.2281C5.0387 17.4071 4.0514 15.6999 4.0514 15.6999C5.6924 16.7788 7.3515 17.454 9.4191 17.8825C12.7831 18.61 16.9675 17.862 20.0928 15.6999C20.0928 15.6999 19.0644 17.4502 16.3704 18.2496C16.9873 19.0492 17.7277 19.9784 17.7277 19.9784C22.2727 19.8271 24 16.7154 24 16.7372C23.9998 9.8441 21.0385 4.2477 21.0385 4.2477ZM8.1645 14.7276C7.0127 14.7276 6.0668 13.6687 6.0668 12.3507C6.151 9.1939 10.1991 9.2037 10.2622 12.3507C10.2622 13.6687 9.3365 14.7276 8.1645 14.7276ZM15.6707 14.7276C14.519 14.7276 13.573 13.6687 13.573 12.3507C13.6654 9.2002 17.663 9.1988 17.7685 12.3507C17.7685 13.6687 16.843 14.7276 15.6707 14.7276Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordIcon);
export default __webpack_public_path__ + "static/media/discord-icon.391c624e0d8f48d9a88d39affb45ec2a.svg";
export { ForwardRef as ReactComponent };